import { useCallback, useMemo } from 'react';

import WfCheckboxGroup from './WfCheckboxGroup';
import { CheckSvg } from '../wf-svg';

import './index.scss';

export interface WfCheckboxProps {
  label?: string;
  checked: boolean;
  required?: boolean;
  onChange: (checked: boolean) => void;
}

function WfCheckbox(props: WfCheckboxProps) {
  const { label, checked, required, onChange } = props;

  const checkboxClassName = useMemo(() => {
    return `wf-checkbox-input ${checked ? 'wf-checkbox-input_selected' : ''}`;
  }, [checked]);

  const handleClick = useCallback(() => {
    onChange(!checked);
  }, [checked, onChange]);

  return (
    <div className="wf-checkbox-container">
      <div className={checkboxClassName} onClick={handleClick}>
        {checked && <CheckSvg />}
      </div>

      <div className="wf-checkbox-label-wrap">
        <label className="wf-checkbox-label-text" onClick={handleClick}>
          {label}
        </label>

        {required && <span className="wf-checkbox-label-required">*</span>}
      </div>
    </div>
  );
}

WfCheckbox.Group = WfCheckboxGroup;

export default WfCheckbox;
